import { useEffect, useRef } from 'react'

export const useGradientShift = ({ isIdleConversation }: { isIdleConversation: boolean }) => {
  const gradientRef = useRef<HTMLDivElement | null>(null)
  const messageFormRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!gradientRef.current || !messageFormRef.current) {
      return
    }

    if (isIdleConversation) {
      gradientRef.current.style.transform = 'scaleY(1)'
    } else {
      gradientRef.current.style.transform = `scaleY(${
        (messageFormRef.current.clientHeight / gradientRef.current.clientHeight) * 2
      })`
    }
  }, [isIdleConversation])

  return {
    gradientRef,
    messageFormRef,
  }
}
